// import { openToast } from "~/components/common/molecules/ToastNotification";
// import history from "~/history";

export const handleUnAuthorize = () => {
  // openToast("Phiên đăng nhập đã hết hạn vui lòng đăng nhập lại", "error");
  localStorage.removeItem("jwt");
  // history.push("/login");
};
